/* unplugin-vue-components disabled */import { render } from "./status-dot.vue?vue&type=template&id=11cd07c4&scoped=true"
const script = {}

import "./status-dot.vue?vue&type=style&index=0&id=11cd07c4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cd07c4"],['__file',"src/controls/status-dot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11cd07c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11cd07c4', __exports__)) {
    api.reload('11cd07c4', __exports__)
  }
  
  module.hot.accept("./status-dot.vue?vue&type=template&id=11cd07c4&scoped=true", () => {
    api.rerender('11cd07c4', render)
  })

}


export default __exports__